/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:11:56
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import sRouter from '@/services/sRouter';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyRechargesCard',

  props: ['subscriber'],

  data() {
    return {
      topUp: 5,
    };
  },

  methods: {
    openRechargesApp() {
      window.openRechargesApp();
    },
    changeUrl(pathObject) {
      sRouter.changeUrl(pathObject, this.$router);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyRechargesCard/component.js